import React, { useEffect, useState } from "react";
import { Compass, MapPin, Phone, Mail, Video, PauseCircle } from "lucide-react";
import { recommendationsApi } from "@/api/client";

const META = {
  VISIT: { icon: MapPin, cls: "bg-teal-50 text-teal-700 border-teal-200", label: "Visit" },
  PHONE: { icon: Phone, cls: "bg-indigo-50 text-indigo-700 border-indigo-200", label: "Phone" },
  EMAIL: { icon: Mail, cls: "bg-amber-50 text-amber-700 border-amber-200", label: "Email" },
  VIDEO_DEMO: { icon: Video, cls: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200", label: "Video demo" },
  WAIT: { icon: PauseCircle, cls: "bg-slate-100 text-slate-500 border-slate-200", label: "Wait" },
};

export function RecommendedChannel({ orgId }) {
  const [rec, setRec] = useState(null);
  const [showWhy, setShowWhy] = useState(false);

  useEffect(() => {
    recommendationsApi.channel(orgId).then((r) => setRec(r.data)).catch(() => {});
  }, [orgId]);

  if (!rec) return null;
  const m = META[rec.channel] || META.WAIT;
  const Icon = m.icon;

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="recommended-channel">
      <Compass className="h-4 w-4 text-slate-400" />
      <span className="text-xs font-semibold text-slate-500">Recommended:</span>
      <button data-testid="recommended-channel-badge" onClick={() => setShowWhy((v) => !v)}
        className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-bold ${m.cls}`}>
        <Icon className="h-3 w-3" /> {m.label}
      </button>
      <span className="text-[11px] text-slate-400">Advisory · deterministic</span>
      {showWhy && rec.reasons?.length > 0 && (
        <ul className="mt-1 w-full space-y-0.5" data-testid="recommended-channel-reasons">
          {rec.reasons.map((r, i) => (
            <li key={i} className="flex items-start gap-1 text-[11px] text-slate-500">
              <span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-slate-300" /> {r}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
